import React from 'react';
import { Home } from './pages/Home';
import { RequestQuote } from './pages/RequestQuote';
export function App() {
  const page = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('page') : null;
  if (page === 'request-a-quote') return <RequestQuote data-id="element-0" data-mp="3k78d1djixmuw" />;
  return <Home data-id="element-1" data-mp="3f9ygzf1mqcy3" />;
}